module.exports = __webpack_public_path__ + "img/ICON_MoneyGrowth_Colors.5b74a63c.svg";